import React, { FC } from 'react';
import styles from '../LandingPageStep.scss';
import clsx from 'clsx';
import LpAsset3 from 'assets/svgs/lp-asset-3.svg';
import LpAsset4 from 'assets/svgs/lp-asset-4.svg';
import LpAsset1 from 'assets/svgs/lp-asset-1.svg';
import LpAsset2 from 'assets/svgs/lp-asset-2.svg';

export const LandingPageStepContentAssetsDesktop: FC = () => {
  return (
    <div className={styles.landingPageStepAssets}>
      <div className={styles.landingPageStepAssetsAnchor}>
        <div className={clsx(styles.landingPageStepAssetsAnchorFloater, styles.left)}>
          <div className={clsx(styles.landingPageStepAssetsImage, styles.hat)}>
            <img
              src="https://static.wixstatic.com/media/058543_05a5f8bce7ea43a2b7a224caa4b2c74b~mv2.jpg/v1/fill/w_211,h_172,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/hat.jpg"
              alt="Landing Page Step Asset"
            />
            <div className={styles.asset4}>
              <LpAsset4 />
            </div>
          </div>
          <div className={clsx(styles.asset1, styles.desktop)}>
            <LpAsset1 />
            <div className={styles.asset2}>
              <LpAsset2 />
            </div>
          </div>
        </div>
        <div className={clsx(styles.landingPageStepAssetsAnchorFloater, styles.right)}>
          <div className={clsx(styles.knobs, styles.desktop)}>
            <div />
            <div />
            <div />
          </div>
          <div className={styles.asset3}>
            <LpAsset3 />
          </div>
          <div className={styles.landingPageStepAssetsImage}>
            <img
              src="https://static.wixstatic.com/media/0784b1_302ee1da81f9408c8dee6022cacbca15~mv2.jpg/v1/fill/w_159,h_338,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Group%204720689.jpg"
              alt="Landing Page Step Asset"
            />
          </div>
        </div>
        <div className={styles.landingPageStepAssetsImage}>
          <img
            src="https://static.wixstatic.com/media/0784b1_f0f5f190cc834df79e9c46eb1a6dc456~mv2.jpg/v1/fill/w_555,h_344,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/HEADER%20CENTER%20IMAGE.jpg"
            alt="Landing Page Step Asset"
          />
        </div>
      </div>
    </div>
  );
};
